import GuestActions from '../../../actions/GuestActions';
import NotificationActions from '../../../actions/NotificationActions';
import { endPoints as GuestEndPoints } from '../../../constants/GuestConstants';
import { endPoints as UserEndPoints } from '../../../constants/UserConstants';
import UserStore from '../../../stores/UserStore';
import AjaxPromises from '../../../utils/AjaxPromises';
import DropdownProfile from './DropdownProfile.react';

class DaysSupplyCalculator extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            visible: false,
            fillDates: false,
            daysInPeriod: false,
            periodPurchased: false,
            daysSupplyRemainingInPeriod: 0,
        }

        this.open = this.open.bind(this);
        this.setRecommendationStart = this.setRecommendationStart.bind(this);
        this.isValid = this.isValid.bind(this);
        this.save = this.save.bind(this);
    }

    open() {
        this.setState({ visible: true });
    }

    setRecommendationStart(val) {
        const now = moment().startOf('day');
        const recommendationStart = moment(val);
        const dayNumber = now.diff(recommendationStart, 'days');
        const periodNumber = dayNumber == 0 ? 1 : Math.ceil(dayNumber / 45);
        const firstPeriodOFfset = periodNumber == 1 ? 1 : 0;
        const daysToPeriodStart = ((45 * (periodNumber - 1)) + 1) - firstPeriodOFfset;
        const daysInPeriod = 45 + firstPeriodOFfset;
        const periodStart = recommendationStart.clone().add(daysToPeriodStart, 'days');
        const periodEnd = periodStart.clone().add(daysInPeriod - 1, 'days');

        this.setState({
            fillDates: periodStart.format('l') + ' - ' + periodEnd.format("l"),
            daysInPeriod: daysInPeriod,
            daysSupplyRemainingInPeriod: daysInPeriod
        });

        if (periodNumber > 8) {
            this.setState({
                fillDates: 'Expired Date Entered',
                daysInPeriod: 0,
                daysSupplyRemainingInPeriod: 0,
            });
        }

        if (recommendationStart.diff(now, 'days') > 0) {
            this.setState({
                fillDates: 'Future Date entered',
                daysInPeriod: 0,
                daysSupplyRemainingInPeriod: 0,
            });
        }
    }

    isValid() {
        return true;
    }

    save() {
        var guest = this.props.guest;

        AjaxPromises.POST(GuestEndPoints.SET_DAYS_SUPPLY_REMAINING, UserStore.getApiData({
            PatientId: guest.Guest_id,
            DaysSupplyRemaining: this.state.daysSupplyRemainingInPeriod
        })).then(res => {
            NotificationActions.addNotification({
                type: res.Result ? 'success' : 'error',
                body: res.Result ? 'Days supply remaining saved' : 'Failed to save days supply remaining'
            });

            if (res.Result) {
                this.setState({
                    loading: false,
                    visible: false,
                    fillDates: false,
                    daysInPeriod: false,
                    periodPurchased: false,
                    daysSupplyRemainingInPeriod: 0, 
                });

                GuestActions.loadFullGuest(guest.Guest_id);
                this.props.onClose();
            } else {
                this.setState({ loading: false });
            }
        });
    }

    render() {
        let valid = this.isValid();

        return (
            <div className='col-6'>
                <div className='popup popup__transparent'>
                    <div className='popup__content days-supply-calculator'>

                        <div className='popup-header'>
                            Days Supply Calculator

                            <div
                                className='popup-close'
                                onClick={() => {
                                    this.setState({             
                                        fillDates: false,
                                        daysInPeriod: false,
                                        periodPurchased: false,
                                        daysSupplyRemainingInPeriod: 0, 
                                    });
                                    this.props.onClose();
                                }}>

                                <i className='fa fa-times' aria-hidden='true' />
                            </div>
                        </div>

                        <div className='days-supply-calculator__content container'>
                            <div className='row'>
                                <label className='col-7 col-form-label'>Recommendation Date</label>
                                <input type='date'
                                    className='col-5 form-control-sm'
                                    onChange={(e) => { this.setRecommendationStart(e.target.value); }} />
                            </div>

                            <div className='row'>
                                <label className='col-7'>Fill Period Start / End</label>
                                <div className='col-5' style={{ fontSize: '0.72em' }}>
                                    {(this.state.fillDates)}
                                </div>
                            </div>

                            <div className='row'>
                                <label className='col-7 col-form-label'>Days Supply Used</label>
                                <input type='number'
                                    className='col-5 form-control-sm'
                                    onChange={(e) => {
                                        this.setState({
                                            periodPurchased: e.target.value,
                                            daysSupplyRemainingInPeriod: this.state.daysInPeriod - e.target.value
                                        });
                                    }}
                                />
                            </div>

                            <div className='row'>
                                <label className='col-7'>Days Supply Remaining</label>
                                <div className='col-5'>
                                    {this.state.daysSupplyRemainingInPeriod}
                                </div>
                            </div>

                            <div className='row float-right pb-2'>
                                <div
                                    className={'adjust-loyalty__ok btn-green ' + (!valid ? 'btn-green__disabled' : '')}
                                    onClick={this.save}>
                                    Save
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DaysSupplyCalculator;


// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/DaysSupplyCalculator.react.jsx